import { jsx as m } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import r from "classnames";
/* empty css             */
const i = ({ className: o, el: a = "div", children: e }) => /* @__PURE__ */ m(a, { className: r("adyen-pe-info-box", o), children: e });
export {
  i as default
};
